"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HierarchicalMenuUnwrapped = void 0;

var _preact = require("preact");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _ArrowDropUpV = _interopRequireDefault(require("@insided/destination/icons/ArrowDropUpV2"));

var _AccordionPanel = _interopRequireDefault(require("@insided/deprecated-control/panel/AccordionPanel"));

var _excluded = ["title"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HierarchicalMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HierarchicalMenu, _Component);

  var _super = _createSuper(HierarchicalMenu);

  function HierarchicalMenu() {
    (0, _classCallCheck2.default)(this, HierarchicalMenu);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(HierarchicalMenu, [{
    key: "isBold",
    value: function isBold(item) {
      var _item$items, _item$items2;

      if (!item.isRefined) {
        return false;
      } // If item is refined and it is a child, then it should be bold


      if (this.props.isChild) {
        return true;
      } // If parent is selected and it has more than 2 children, then it should be bold (not sure who decided this rule)


      return ((_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length) > 1 && ((_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : _item$items2.filter(function (item) {
        return item.isRefined;
      }).length) === 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          items = _this$props.items,
          refine = _this$props.refine,
          createURL = _this$props.createURL,
          _this$props$isChild = _this$props.isChild,
          isChild = _this$props$isChild === void 0 ? false : _this$props$isChild;
      return (0, _preact.h)("div", {
        className: "instant-search__category-filter"
      }, (0, _preact.h)("ul", null, items.map(function (item, index) {
        return (0, _preact.h)("li", {
          key: index,
          className: "instant-search__filter-list-item"
        }, (0, _preact.h)("div", {
          role: "button",
          tabIndex: 0,
          onClick: function onClick(event) {
            event.preventDefault();
            refine(item.value);
          },
          className: (0, _classnames.default)('instant-search-filter__label-wrapper', {
            refined: item.isRefined,
            bold: _this.isBold(item)
          })
        }, (0, _preact.h)("span", null, !isChild && (0, _preact.h)(_ArrowDropUpV.default, {
          width: 10,
          height: 10,
          fill: "#6B707E",
          className: !item.items ? 'instant-search-filter__closed' : 'instant-search-filter__open'
        }), item.label)), Boolean(item.items) && (0, _preact.h)(HierarchicalMenu, {
          items: item.items,
          refine: refine,
          createURL: createURL,
          isChild: true
        }));
      })));
    }
  }]);
  return HierarchicalMenu;
}(_preact.Component);

var WithAccordion = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(WithAccordion, _Component2);

  var _super2 = _createSuper(WithAccordion);

  function WithAccordion() {
    (0, _classCallCheck2.default)(this, WithAccordion);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(WithAccordion, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      // Problem: In Sidebar, we want to hide this filter if there are no items.
      // Solution: We don't have the information of "number of items" in the parent (Sidebar) component, so emitting from here.
      //
      // Tried wrapping Sidebar with connectStateResults to get the number of items directly in Sidebar,
      // but turns out we cannot use connectStateResults in a component that has connectHierarchicalMenu or connectRefinementList, it results in an infinite loop.
      // Reference: https://github.com/algolia/instantsearch/issues/5269
      if (previousProps.items.length !== this.props.items.length) {
        this.props.onItemsChange(this.props.items.length);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          props = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      return (0, _preact.h)(_AccordionPanel.default, {
        panels: [{
          title: title,
          body: (0, _preact.h)(HierarchicalMenu, props)
        }],
        defaultActivePanelIndex: 0
      });
    }
  }]);
  return WithAccordion;
}(_preact.Component);
/**
 * Unwrapped component for testing purposes.
 * @internal
 */


exports.HierarchicalMenuUnwrapped = WithAccordion;

/**
 * Connected component wrapped with Algolia's hierarchical menu connector.
 */
var _default = (0, _connectors.connectHierarchicalMenu)(WithAccordion);

exports.default = _default;